import * as React from 'react';
import IZoom from './IZoom';
import * as style from './ZoomStyle.module.scss'

const Zoom = (props: IZoom) => {

  const renderButtons = () => {
    const values = ['7d', '1m', '3m', '1y', 'All'];

    return values.map((el) => {
      const isActive = el === props.value ? style.btnActive : '';

      return (
        <button onClick={() => {props.setZoomValue(el);}} className={[style.btn, isActive].join(' ')} key={el}>
          {el}
        </button>
      );
    });
  };

  return (
    <div className={style.zoom}>
      <p>Zoom</p>
      {renderButtons()}
    </div>
  );
};

export default Zoom;
